import { AdapterInterface } from '@/common/interfaces';
import { CoreQuery } from '@/common/services/core-query';
import http from '../http-client';

export function getAndAdaptData<T = any>(q: CoreQuery, adapter: AdapterInterface<T>, ...fields: string[]): any {
    return http
        .get(q.query, q.axiosConfigParams)
        .then(({ data }) => data)
        .then(response => {
            if (Array.isArray(response.data)) {
                const { data = [], total, last_page: lastPage } = response;
                const adaptedData = data.map((member: any) => adapter.adapt(member));

                return {
                    data: adaptedData,
                    total,
                    lastPage,
                };
            } else {
                if (Array.isArray(fields) && fields.length > 0) {
                    const adapted = fields.reduce((acc, c) => (acc ? acc[c] : acc), response);

                    return {
                        initial: response,
                        adapted,
                    };
                } else {
                    return adapter.adapt(response);
                }
            }
        });
}

export function getAndAdaptSingleDatum<T = any>(q: CoreQuery, adapter: AdapterInterface<T>) {
    return http.get(q.query, q.axiosConfigParams).then(response => {
        return adapter.adapt(response.data);
    });
}
